import OrderEditViewStore from '@components/order/stores/OrderEditViewStore';
import UserAddressEditViewStore from '@components/user-address/stores/UserAddressEditViewStore';
import { Box } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import OrderCartAction from './OrderCartAction';
import OrderFoodList from './order-food/OrderFoodList';
import OrderLiveStatus from './live-status/OrderLiveStatus';

interface OrderCartProps {
    orderEditViewStore: OrderEditViewStore;
    userAddressEditViewStore: UserAddressEditViewStore;
}

const OrderCart: React.FC<OrderCartProps> = observer(({ orderEditViewStore, userAddressEditViewStore }) => {
    const { insertedOrder } = orderEditViewStore;

    if (insertedOrder !== undefined) {
        return <OrderLiveStatus orderEditViewStore={orderEditViewStore} />
    }

    return (
        <>
            <Box
                flex={"1 1 auto"}
                sx={{
                    overflowY: "auto",
                    scrollbarWidth: "1px"
                }}>
                <OrderFoodList orderEditViewStore={orderEditViewStore} />
            </Box>

            <Box p={2} sx={{ boxShadow: "0 -1px 5px rgb(0 0 0 / 15%)", borderBottomLeftRadius: 16, borderBottomRightRadius: 16 }}>
                <OrderCartAction orderEditViewStore={orderEditViewStore} userAddressEditViewStore={userAddressEditViewStore} />
            </Box>
        </>
    )
})

export default OrderCart;